import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const AlertIcon = ({
  title = 'Alert',
  style = {
    // This icon was initially imported with a fill color
    color: '#FF9A00',
  },
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent viewBox="0 0 24 24" title={title} style={style} {...props}>
    {/* prettier-ignore */}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.392 20.6668L11.9997 2.3335L1.60742 20.6668H22.392ZM12.0557 16.8615C12.6437 16.8615 13.1117 17.3295 13.1117 17.9175C13.1117 18.5055 12.6437 18.9735 12.0557 18.9735C11.4677 18.9735 10.9997 18.5055 10.9997 17.9175C10.9997 17.3295 11.4677 16.8615 12.0557 16.8615ZM13.313 8.00039L12.9797 15.1297H11.1317L10.7983 8.00039H13.313Z"
    />
  </CreateIconComponent>
);

export default AlertIcon;
